export const vibrate = (milliseconds = 10) => navigator.vibrate?.(milliseconds)
